import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logoPachon from "../../assets/cez/miembros/j-pachon.png";
import logoMeuDoc from "../../assets/cez/miembros/meudoc.png";
import logoAcuarios from "../../assets/cez/miembros/inversiones-acuarios.png";

export const cezMiembros = [
  { id: "j-pachon", nombre: "J. Pachón S.A.S. Constructora", logo: logoPachon },
  { id: "meudoc", nombre: "MeuDoc", logo: logoMeuDoc },
  { id: "inversiones-acuarios", nombre: "Inversiones Acuarios", logo: logoAcuarios },
];

const NextArrow = ({ onClick }) => (
  <button
    type="button"
    className="absolute top-1/2 -right-3 sm:-right-5 z-10 flex -translate-y-1/2 items-center justify-center h-10 w-10 rounded-full bg-white text-[#1746a2] shadow-md border border-slate-200 hover:bg-[#1746a2] hover:text-white transition"
    onClick={onClick}
    aria-label="Siguiente"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M9.29 6.71a1 1 0 011.42 0L15 11l-4.29 4.29a1 1 0 11-1.42-1.42L12.17 12l-2.88-2.88a1 1 0 010-1.41z" />
    </svg>
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    type="button"
    className="absolute top-1/2 -left-3 sm:-left-5 z-10 flex -translate-y-1/2 items-center justify-center h-10 w-10 rounded-full bg-white text-[#1746a2] shadow-md border border-slate-200 hover:bg-[#1746a2] hover:text-white transition"
    onClick={onClick}
    aria-label="Anterior"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M14.71 6.71a1 1 0 010 1.41L11.83 12l2.88 2.88a1 1 0 01-1.42 1.42L9 12l4.29-4.29a1 1 0 011.42 0z" />
    </svg>
  </button>
);

function CezMiembrosCarousel({ label, title, intro }) {
  const slides = [...cezMiembros, ...cezMiembros];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2800,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="py-16 px-6 sm:px-10 lg:px-16 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-3xl">
          {label && (
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-[#1746a2]">{label}</p>
          )}
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-[#0b1f3f]">{title}</h2>
          {intro && <p className="mt-4 text-slate-600 text-lg leading-relaxed">{intro}</p>}
        </div>

        <div className="relative mt-10 px-2 sm:px-6">
          <Slider {...settings}>
            {slides.map((miembro, index) => (
              <div key={`${miembro.id}-${index}`} className="px-3 py-2">
                <article className="flex h-44 sm:h-48 flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white px-6 py-5 shadow-sm">
                  <img
                    src={miembro.logo}
                    alt={miembro.nombre}
                    className="max-h-28 w-full object-contain"
                  />
                  <p className="mt-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-600">
                    {miembro.nombre}
                  </p>
                </article>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default CezMiembrosCarousel;
